import axios from 'axios';
import { COVID_SUMMARY_URL } from '../constants';
import covidData from '../data/covid.json';

export default async function getWorldData() {
  try {
    const response = await axios(COVID_SUMMARY_URL);
    const { Global: global, Date: date } = response.data;
    let { Countries: countries } = response.data;
    countries = countries.map((country, index) => ({
      ...country,
      id: index,
    }));
    return { global, countries, date };
  } catch (error) {
    console.log(`Failed to fetch countries: ${error.message}`, error);
    // throw new Error(error.message);
  }

  // in case API throws error
  const { Global: global, Date: date } = covidData;
  let { Countries: countries } = covidData;
  countries = countries.map((country, index) => ({
    ...country,
    id: index,
  }));
  return { global, countries, date };
}
